import React from 'react';
import cache from 'lscache';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import VpUserIcon from '@vtmn-play/icons/react/VpUserIcon';
import VpRunIcon from '@vtmn-play/icons/react/VpRunIcon';

import { logout } from '../../../apis/userinfo';
import useToaster from '../../../utils/hooks/useToaster';
import { selectUserDisplayName } from '../../../store/selectors/userInfo';
import { AppButton } from '../../shared/Buttons/AppButton';
import { ButtonDropdown } from '../../shared/Dropdowns/ButtonDropdown';

export const LogoutDropdown = () => {
  const displayName = useSelector(selectUserDisplayName);

  const { addErrorToast } = useToaster();
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      await logout();

      const hasCachedKeys = Object.keys(localStorage).some(storageKey => storageKey.includes('lscache'));

      if (hasCachedKeys) {
        cache.flush();
      }
    } catch (error) {
      addErrorToast(t('error.generic.message'));
    }
  };

  return (
    <ButtonDropdown
      className="text-black"
      label={displayName}
      startSlot={<VpUserIcon />}
      data-testid="dropdown-userinfo"
      contentRole="menu"
      aria-label={t('toolbar.top.userinfos.button.logout')}
    >
      <AppButton className="text-black" onClick={handleLogout} startSlot={<VpRunIcon />} data-testid="logout-button" role="menuitem">
        {t('toolbar.top.userinfos.button.logout')}
      </AppButton>
    </ButtonDropdown>
  );
};
